import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

function useTitle(title, restoreOnUnmount = false) {
	const { t } = useTranslation();
	const prevTitleRef = useRef(document.title);
	useEffect(() => {
		document.title = t(title) + ' | ' + t('Cayesh');
		if (restoreOnUnmount) {
			return () => {
				document.title = prevTitleRef.current;
			};
		} else {
			return () => {
				document.title = t('Cayesh');
			};
		}
	}, [title]);
}

export default typeof document !== 'undefined' ? useTitle : () => {};
